  <div class="container-fluid">
    <div class="row" style="padding-top: 15px">
      <div class="col-md-12 mt-2">
        <h4 [innerHTML]="'MyNotifications' | translate"></h4>
      </div>
    </div>
    <hr />
    <div class="form-group row flex-align-items space-between">
      <app-label
        label="ReceiveMonthlyReport"
        tooltip="ReceiveMonthlyReportTooltip"
        tooltipPlacement="top"
        class="col"
      />
      <app-switch
        [(ngModel)]="notifications.monthlyReport"
        (change)="changeNotification('monthlyReport', $event)"
        class="col-md-auto"
      />
    </div>
    <div *ngFor="let type of EventTypes" class="form-group row">
      <app-label
        [label]="'Notifications.Event.'+type+'.label'"
        [tooltip]="'Notifications.Event.'+type+'.tooltip'"
        tooltipPlacement="top"
        class="col"
      />
      <div class="col-xl-3">
        <select
          (change)="changeEventNotification(type, $event.target.value)"
          [(ngModel)]="notifications.eventNotificationMinSeverities[type]"
          class="form-control"
        >
          <option value="null">{{ 'NoAlert' | translate }}</option>
          <option value="1">LOW</option>
          <option value="2" selected>MEDIUM</option>
          <option value="3">HIGH</option>
        </select>
      </div>
    </div>
  </div>
